import { createRouter, createWebHistory } from "@ionic/vue-router";
import { defaultroutes } from "./routes";
import routeData from "./routes.json"; // replace with the path to your JSON file
const routes = routeData.map((route: any) => ({
  path: route.path,
  name: route.name,
  component: () => import(`@/views/${route.component}`),
  redirect: route.redirect,
  children: route.children
    ? route.children.map((child: any) => ({
        path: child.path,
        name: child.name,
        component: () => import(`@/views/${child.component}`),
        redirect: child.redirect !== "" ? child.redirect : undefined,
      }))
    : undefined,
}));

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: defaultroutes.concat(routes),
});

export default router;

